import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Global stylesheets — order matters:
//   pixel.css  → CSS custom properties, pixel borders, retro palette, RTL base
//   animations.css → reusable keyframes
import './styles/theme-system.css'; 

import './styles/theme-light-override.css';  // ← این رو اضافه کن  // ← اول
import './styles/animations.css';
import './styles/atari_overlay.css';
import "./styles/arcade-theme.css";

import "./styles/arcade-patch-v2.css";
import './styles/font-scale-patch.css';
import './styles/responsive-patch.css';
import AtariBackground from "./components/common/AtariBackground";
import AtariCursor     from "./components/common/AtariCursor";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
  <AtariBackground />   {/* ← اول */}
  <AtariCursor />       {/* ← دوم */}
  
  <div style={{ position: "relative", zIndex: 1 }}>
    <React.StrictMode>
    <App />
  </React.StrictMode>
  </div>
</>
  
);